import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd, ActivatedRoute, Data, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LoginService } from '@serengeti/serengeti-common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {

	links = [];
	routeSubscription: Subscription;
	topMenu: any;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private loginService: LoginService,
		private translate: TranslateService
	) {
		this.routeSubscription = this.router.events.pipe(
			filter((event: RouterEvent) => event instanceof NavigationEnd)
		).subscribe(() => {
			let data = this.route.root.firstChild.snapshot.data;

			if (!data.title) {
				if (this.route.root.firstChild.snapshot.firstChild) {
					data = this.route.root.firstChild.snapshot.firstChild.data;
				}
			}

			let url = this.router.url;
			let title = this.route.snapshot.queryParamMap.get('title');

			if (title) {
				data.title = title;
			}
			this.handleNavigationData(url, data);
		});
	}

	handleNavigationData(url: string, data: Data) {
		if (data.title) {
			if (url.indexOf('?') !== -1) {
				url = url.substring(0, url.indexOf('?'));
			}

			let linkFound = false;

			if (this.links.length === 0) {
				this.links = JSON.parse(this.loginService.getScreenConfig('navigation', 'path', "[]"));
			}
			for (const link of this.links) {
				if (link.url === url) {
					const index = this.links.indexOf(link);
					this.links.splice(index);
					data = link.data;
					linkFound = true;
					break;
				}
			}
			if (!linkFound) {
				if (data.root) {
					this.links = [];
				}	
			}

			try {
				const titles = data.title.split('\.');
				let topTitle = titles[0];

				if (topTitle === 'lib') {
					topTitle = titles[1];
				}
				if (topTitle !== data.title) {
					this.messages('sidepopup.topmenu.title.' + topTitle).then((message: string) => {
						this.topMenu = message;
					});	
				} else {
					if (url.indexOf('content:')) {
						const contentUrl = url.substring(url.indexOf('content:') + 8);
						const contentTitles = contentUrl.split('\/');

						this.messages('sidepopup.topmenu.title.' + contentTitles[0]).then((message: string) => {
							this.topMenu = message;
						});	
					}
				}
			} catch (error) {
				this.messages('sidepopup.topmenu.title.home').then((message: string) => {
					this.topMenu = message;
				});
			}

			if (this.links.length !== 0) {
				if (this.links[this.links.length - 1].data.title != data.title) {
					this.links.push({
					url: url,
					data: data,
					topMenu: this.topMenu
					});
				} else {
					this.links[this.links.length - 1].url = url;
					this.links[this.links.length - 1].topMenu = this.topMenu;
				}
			} else {
				this.links.push({
					url: url,
					data: data,
					topMenu: this.topMenu
				});
			}

			this.loginService.setScreenConfig('navigation', 'path', JSON.stringify(this.links));
		}
	}

	async messages(message : string) {
		return await this.translate.get(message).toPromise();
	}
}
